import { useMutation } from '@apollo/client';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import {
  createTheme,
  ThemeProvider,
  StyledEngineProvider,
} from '@mui/material/styles';
import DeleteForeverIcon from '@mui/icons-material/DeleteForever';
import { useSnackbar } from 'notistack';
import React from 'react';
import { DELETE_COMMENT } from '../../../helpers/graphql/comments';
import { red } from '@mui/material/colors';

const theme = createTheme({
  palette: {
    primary: red,
  },
});

export default function DeleteDialog({
  setDeleted,
  permlink,
  btnText,
  dialogText,
  open,
  setOpen,
  author,
}) {
  const { enqueueSnackbar } = useSnackbar();

  const [deleteComment] = useMutation(DELETE_COMMENT);

  const handleCommentDelete = () => {
    deleteComment({
      variables: author
        ? {
            permlink,
            author,
          }
        : { permlink },
    })
      .then(({ data }) => {
        if (data.deleteComment.success) {
          setDeleted(true);
          setOpen(false);
        } else {
          enqueueSnackbar(
            `Comment could not be deleted: ${data.deleteComment.message}`,
            {
              variant: 'error',
            },
          );
        }
      })
      .catch(() => {
        setOpen(false);
        enqueueSnackbar('Comment could not be deleted', {
          variant: 'error',
        });
      });
  };

  return (
    <Dialog
      open={open}
      onClose={() => setOpen(undefined)}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <DialogTitle id="alert-dialog-title">{btnText}?</DialogTitle>
      <DialogContent>
        <DialogContentText>{dialogText}</DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={() => setOpen(undefined)} color="primary">
          Cancel
        </Button>{' '}
        <StyledEngineProvider injectFirst>
          <ThemeProvider theme={theme}>
            <Button
              variant="contained"
              onClick={handleCommentDelete}
              color="primary"
            >
              <DeleteForeverIcon />
              {btnText}
            </Button>
          </ThemeProvider>
        </StyledEngineProvider>
      </DialogActions>
    </Dialog>
  );
}
